const numberValidation = (evt) => {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
      return false;
    } else {
      return true;
    }
  };

const slideValidation = async (fields, action) => {
  for (const item of fields) {
    if (!(await action(item))) {
      var elementCheck = document.getElementById(item);
      if (elementCheck) {
        elementCheck.focus();
      }
      return item;
    }
  }
  return 'Success';
};

const dobValidation = (DobDay, DobMonth, DobYear) => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const month =
    monthNames.indexOf(DobMonth) !== -1
      ? monthNames.indexOf(DobMonth) + 1
      : null;
  var date = new Date(parseInt(DobYear), parseInt(month) - 1, parseInt(DobDay));
  var dateStatus = parseInt(month) == date.getMonth() + 1;
  return dateStatus;
};
const nameValidate = (evt) => {
  const char = String.fromCharCode(evt.charCode);
  if (!/^[a-zA-Z\s]*$/.test(char)) {
    evt.preventDefault();
    return false;
  }
  evt.target.value = evt.target.value.trimStart();
};
export {
  slideValidation,
  numberValidation,
  dobValidation,
  nameValidate
};
  